import type { GridColDef } from "@mui/x-data-grid-premium";
import DataSubmissionStatusTag from "@entrilia/shared/components/dataCollection/DataSubmissionStatusTag";
import FormattedDueDate from "@entrilia/shared/components/dataCollection/FormattedDueDate";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import { convertISODate, convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import { nameof } from "@entrilia/shared/utilities/typeHelper";
import type { DataCollectionSubmissionInfo } from "../../../../api/types/dataCollectionTypes";
import { getRecipientName } from "../dataCollectionsGridHelper";

export const columnDefinitions: GridColDef<DataCollectionSubmissionInfo>[] = [
  {
    field: nameof<DataCollectionSubmissionInfo>("recipientName"),
    headerName: "Portfolio Company",
    flex: 1,
    minWidth: 160,
    renderCell: ({ row }) => (
      <GridTextHoverLink to={row.isRecipientMissing ? undefined : row.id} text={getRecipientName(row)} />
    ),
  },
  {
    field: nameof<DataCollectionSubmissionInfo>("requestTemplateName"),
    headerName: "Template",
    flex: 1,
    minWidth: 160,
  },
  {
    field: nameof<DataCollectionSubmissionInfo>("reportingDate"),
    headerName: "Reporting Date",
    flex: 0.5,
    minWidth: 120,
    valueFormatter: (value: string) => convertISODate(value),
  },
  {
    field: nameof<DataCollectionSubmissionInfo>("status"),
    headerName: "Status",
    flex: 0.5,
    minWidth: 160,
    renderCell: ({ row }) => <DataSubmissionStatusTag status={row.status} />,
  },
  {
    field: nameof<DataCollectionSubmissionInfo>("auditory"),
    headerName: "Recipient Type",
    flex: 1,
    minWidth: 160,
    valueFormatter: (value: string) => (value ? autoFormatCamelCase(value) : ""),
  },
  {
    field: nameof<DataCollectionSubmissionInfo>("dueDate"),
    headerName: "Due Date",
    flex: 0.5,
    minWidth: 120,
    renderCell: ({ row }) =>
      row.status === "Completed" ? convertISODate(row.dueDate) : <FormattedDueDate dueDateIsoString={row.dueDate} />,
  },
  {
    field: nameof<DataCollectionSubmissionInfo>("submittedBy"),
    headerName: "Submitted by",
    flex: 1,
    minWidth: 160,
  },
  {
    field: nameof<DataCollectionSubmissionInfo>("submittedAt"),
    headerName: "Submitted at",
    flex: 0.5,
    minWidth: 160,
    valueFormatter: (value: string | undefined) => convertISODateTime(value),
  },
];
